import React from 'react';
import { Button, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SortableElement } from 'react-sortable-hoc';

/**
 * Index is a required prop for react-sortable-hoc but keeps getting marked as undefined
 * - hence why imageNumber is now used
 */
// eslint-disable-next-line no-unused-vars
const SortableImage = SortableElement(({ handleDeleteFile, image, imageNumber, index }) => (
  <Col xs={3} className="file-container py-3">
    <div className="file-border px-3 pt-2 cursor-move">
      <div className="d-flex">{imageNumber}</div>
      <div className="thumb-container d-flex justify-content-center align-items-center mt-2 mb-3">
        <img className="w-100 mh-100 opacity-50" src={image} alt="No Thumbnail" />
        <FontAwesomeIcon
          icon="check-circle"
          size="3x"
          className="position-absolute color-success"
        />
      </div>
      <Button className="mt-0" color="link" onClick={() => handleDeleteFile(imageNumber)}>
        Delete
      </Button>
    </div>
  </Col>
));

export default SortableImage;
